// src/PageLogin.js
import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

function PageLogin() {
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [chargement, setChargement] = useState(false);

  const seConnecter = async () => {
    setErreur('');
    setChargement(true);

    try {
      await signInWithEmailAndPassword(auth, email, motDePasse);
      // Pas besoin de rediriger manuellement — on va gérer ça
      // automatiquement dans PageDiaporama grâce à onAuthStateChanged
    } catch (err) {
      console.error(err);
      setErreur('Courriel ou mot de passe incorrect.');
    }

    setChargement(false);
  };

  return (
    <div>
      <h2>Connexion propriétaire</h2>
      <div>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Courriel"
        />
      </div>
      <div>
        <input
          type="password"
          value={motDePasse}
          onChange={(e) => setMotDePasse(e.target.value)}
          placeholder="Mot de passe"
        />
      </div>
      <button onClick={seConnecter} disabled={chargement}>
        {chargement ? 'Connexion...' : 'Se connecter'}
      </button>
      {erreur && <p style={{ color: 'red' }}>{erreur}</p>}
    </div>
  );
}

export default PageLogin;